angular.module('unica_notification_template.notification_template_services')

.factory('NotificationTemplateListService', function($http, getBaseApiURL) {

	var notificationTemplateListService = {};

	notificationTemplateListService.list = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-template/list/' + eventId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.notification_templates;
			}

		});
	};

	notificationTemplateListService.get = function (notificationId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-template/detail/' + notificationId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.notification_template;
			}

		});

	};

	return notificationTemplateListService;

})
;